import {
    NEXT_SUBMIT_BEGIN,
    NEXT_SUBMIT_SUCCESS,
    NEXT_SUBMIT_FAIL
  } from '../middleware/types'
  
  const initialState = {
    ACTION_loading: false,
    error: {},
    response : {}
  }

  export default (state = initialState, action) => {
    switch (action.type) {
      case NEXT_SUBMIT_BEGIN:
        return {
          ...state,
          ACTION_loading: true
        }
      case NEXT_SUBMIT_SUCCESS:
          return {
              ...state,
              ACTION_loading: false,
              response: {
                ...action.payload
              }
          }
      case NEXT_SUBMIT_FAIL:
        return {
          ...state,
          ACTION_loading: false,
          error: action.payload
        }
      default:
        return state
    }
  }